// 🔽 IMPORTS
import React, { useEffect, useState, useRef } from "react";
import { FaTelegram } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Progress } from "../components/ui/progress";
import { Card, CardContent } from "../components/ui/card";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import HighPerformanceAd from "../components/HighPerformanceAd";
import axios from '../axiosInstance';
import { Sidebar } from "../components/Sidebar";
import { Header } from "../components/Header";
import KpiCards from "../components/KpiCards";

import iconGoal from "../assets/images/goal.png";
import iconDraw from "../assets/images/draw.png";
import iconBonus from "../assets/images/bonus.png";
import iconCoinz from "../assets/images/logo192.png";
import iconSurf from "../assets/images/surf.png";

import { RecentActivity } from "../components/RecentActivity";
import { Footer } from "../components/ Footer";

function DrawAvailableModal({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center px-4">
      <div className="bg-gray-900 border border-cyan-600 rounded-2xl shadow-2xl max-w-md w-full p-6 text-white relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-400 hover:text-white text-xl font-bold"
          aria-label="Close modal"
        >
          &times;
        </button>
        <h2 className="text-2xl font-semibold mb-4 text-cyan-400"><img src={iconDraw} alt="Coinz Icon" className="w-4 h-4 sm:w-6 sm:h-6" /> Draw is Ready!</h2>
        <p className="mb-4">Your free hourly draw is now available. Try your luck and win Coinz!</p>
        <button
          onClick={() => {
            window.location.href = "/draw";
          }}
          className="bg-cyan-600 hover:bg-cyan-700 text-white font-bold py-2 px-4 rounded w-full"
        >
          Go to Draw
        </button>
      </div>
    </div>
  );
}


function UpdateModal({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center px-4">
  <div
    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
    onClick={onClose}
  >
    <div
      className="bg-gray-800 rounded-lg shadow-lg p-6 max-w-md w-full text-white"
      onClick={(e) => e.stopPropagation()}
    >
      <h2 className="text-2xl font-bold mb-4 text-center">
        <span className="text-sm font-semibold text-yellow-400 uppercase tracking-wide bg-yellow-900 bg-opacity-20 px-2 py-1 rounded">
          Happy Days :
        </span>{" "}
        Doubled experience !
      </h2>
      <p className="mb-4 text-center text-sm leading-relaxed">
        Until Sunday 11:59 PM:<br /><br />
        • Draw-related xp gains are multiplied by 2.<br />
        • Autosurf xp gains are multiplied by 2.<br />
        • Ad purchases now provide 4000 XP per transaction.<br /><br />
        This is an opportunity to optimize your activity and enhance your account value.
      </p>

      <div className="mt-6">
        <p className="text-center text-sm text-gray-400 mb-2">
          Follow us for updates and news:
        </p>
        <div className="flex justify-center space-x-4">
          <a
            href="https://x.com/coinzup2025"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white transition"
          >
            <FaXTwitter size={20} />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61576040825765"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white transition"
          >
            <FaFacebookF size={20} />
          </a>
          <a
            href="https://t.me/coinzup2025"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white transition"
          >
            <FaTelegram size={20} />
          </a>
        </div>
      </div>

      <button
        onClick={onClose}
        className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md transition"
      >
        Acknowledge
      </button>
    </div>
  </div>
</div>
  );
}

function BonusModal({ onClose }) {
  return (
    
      <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center px-4">
        <div className="bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl max-w-md w-full p-6 text-white relative">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-3 right-4 text-gray-400 hover:text-white text-xl font-bold"
            aria-label="Close modal"
          >
            &times;
          </button>
  
          {/* Title */}
          <h2 className="text-2xl font-semibold mb-4 text-blue-400">
          🎁 Daily Bonus Available!
          </h2>
  
                <p className="mb-4">Don't forget to claim your daily bonus now!</p>
          <button
            onClick={() => {
              window.location.href = "/bonus";
              setShowDailyBonusModal(false);
            }}
            className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-2 px-4 rounded"
          >
            Claim my bonus
          </button>
        </div>
      </div>
    );
}

export default function DashboardPage({ onLogout }) {
  // 📊 ÉTATS LOCAUX : gestion des données utilisateur
  const [coinz, setCoinz] = useState(0);
  const [options, setOptions] = useState(0);
  const [weeklyProfit, setWeeklyProfit] = useState(0);
  const [username, setUsername] = useState(null);
  const [selfWeeklyProfit, setSelfWeeklyProfit] = useState(0) // Son propre bénéfice
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCooldown, setIsCooldown] = useState(false); // Pour gérer le cooldown
  const [latestGain, setLatestGain] = useState(0); // Dernier gain du tirage
  const [now, setNow] = useState(Date.now());
  const navigate = useNavigate();
  // const token = localStorage.getItem("token"); // Récupérer le token depuis le localStorage
  const [history, setHistory] = useState([]);
  const [refCode, setRefCode] = useState(""); // Pour afficher le code de parrainage
  const [copied, setCopied] = useState(false);
  const [toast, setToast] = useState({ message: "", type: "" });
  const [userLevel, setUserLevel] = useState(1);
  const [userXP, setUserXP] = useState(0);
  const [xpForNextLevel, setXpForNextLevel] = useState(100);
  // 🔄 MENU UTILISATEUR (icône) : ouverture/fermeture du menu
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const recaptchaRef = useRef();
  const [captchaToken, setCaptchaToken] = useState(null);
  const [showNewsModal, setShowNewsModal] = useState(false);
  const [stats, setStats] = useState(null);
  const [hasClaimableBonus, setHasClaimableBonus] = useState(false);
  const [showDailyBonusModal, setShowDailyBonusModal] = useState(false);
  const [error, setError] = useState(null);
  const [cooldownTime, setCooldownTime] = useState(null);
  const [timeLeft, setTimeLeft] = useState(0);
  const [showDrawModal, setShowDrawModal] = useState(false);

  // V0.6.0 - Update UI
  const targetCoinz = 100000;
  const progressPercent = (coinz / targetCoinz) * 100;

  // 🔓 DÉCONNEXION : appel à la fonction onLogout passée en prop
  const handleLogout = () => {
    onLogout(); // Déconnexion en parent (App.js)
  };

  const showToast = (message, type = "error") => {
	
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };
  
  // COPIE : Referal link
  const handleCopyReferral = () => {
	  const link = `${window.location.origin}/register?refer=${refCode}`;
	  navigator.clipboard.writeText(link).then(() => {
		setCopied(true);
		setTimeout(() => setCopied(false), 2000); // Réinitialise après 2 secondes
	  });
 };

  // 📡 RÉCUPÉRATION DES DONNÉES UTILISATEUR via l'API
  const getUserData = () => { 

    axios.get(`/api/user/me`, { withCredentials: true }) 
      .then((response) => {
        const { coinz, options, systemCoinz, weeklyProfit, lastclaim, ref_code, userLevel, user_Xp, xpForNextLevel, username  } = response.data;
		    
       const valeurCalculee = options > 0 ? (( systemCoinz / weeklyProfit) * options) : 0;  // On évite la division par 0
		
		setSelfWeeklyProfit(valeurCalculee);
    setCoinz(coinz);
    setOptions(options);
    setWeeklyProfit(weeklyProfit);
	  setRefCode(ref_code); // Mise à jour de l'état
		setUserLevel(userLevel);
		setUserXP(user_Xp);
		setXpForNextLevel(xpForNextLevel);
    setUsername(username);
		setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
        setLoading(false);
      });
  };
  
  const getBonusStatus = async () => {
    try {
      const response = await axios.get(`/api/bonus-status`, { withCredentials: true });
      const { isEligible, claimed } = response.data;
  
      // Vérifie s'il y a AU MOINS UN bonus claimable pour le bouton général :
      const claimable = Object.entries(isEligible).some(
        ([id, eligible]) => eligible && !claimed[id]
      );
      setHasClaimableBonus(claimable);
  
      // Vérifie spécifiquement pour le DAILY BONUS (id = 7) :
      if (isEligible[7] && !claimed[7]) {
        setShowDailyBonusModal(true);
      } else {
        setShowDailyBonusModal(false);
      }
    } catch (error) {
      console.error("Erreur en récupérant le bonus status :", error);
    }
  };

const fetchTransactionHistory = async (userId) => {
	
	
  try {
    const response = await axios.get(`/api/transactions/`,{ withCredentials: true });
    if (!response.data || response.data.length === 0) {
      // console.warn("Aucune transaction trouvée pour cet utilisateur.");
      setHistory([]); // On met un tableau vide par sécurité
    } else {
      setHistory(response.data);
    }
  } catch (error) {
    console.error("Erreur récupération de l'historique :", error);
  }
};

const fetchStats = async () => {
  try {
    const res = await axios.get(`/api/user/stats`, { withCredentials: true });
    const data = res.data;
    
    setStats(data);
  } catch (err) {
    console.error("Erreur fetchStats:", err);
    setError(err.message);
  }
};


const handleCloseModal = () => {
  localStorage.setItem("HappyHour2", "seen");
  setShowNewsModal(false);
}; 



 // 📡 RÉCUPÉRATION DES DONNÉES UTILISATEUR via l'API au chargement du composant
useEffect(() => {
  document.title = "Dashboard | CoinzUp";

  //const hasSeenUpdate = localStorage.getItem("HappyHour2");
  //if (!hasSeenUpdate) {
  //  setShowNewsModal(true);
  //}

  getUserData();
  fetchStats();
  fetchTransactionHistory(); // Tu peux aussi garder ça ici si besoin
  getBonusStatus();

  const storedCooldown = localStorage.getItem("cooldownTime");
  if (storedCooldown) {
    setCooldownTime(Number(storedCooldown));
  }



}, []);

useEffect(() => {

  if (!cooldownTime) return;

  const updateTimer = () => {
    const now = Date.now();
    const diff = cooldownTime - now;
    setTimeLeft(diff > 0 ? diff : 0);    
   
  };

  updateTimer();
  const intervalId = setInterval(updateTimer, 1000);

  return () => clearInterval(intervalId);
}, [cooldownTime]);

const isAvailable = timeLeft === 0;

 // Ici, tu peux mettre le useEffect qui écoute isAvailable
  useEffect(() => {
    if (isAvailable) {
      setShowDrawModal(true);
    } else {
      setShowDrawModal(false);
    }
  }, [isAvailable]);
  
const formatTime = (ms) => {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((totalSeconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (totalSeconds % 60).toString().padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};

const handleDrawClick = () => {
  if (!isAvailable) return;
  window.location.href = "/draw";
};


const activityData = [
  {
    type: "Draws",
    totalCount: stats?.draws_count ?? 0,
    totalCoinz: stats?.draws_total ?? 0,
  },
  {
    type: "Autosurf",
    totalCount: stats?.autosurf_visits_count ?? 0,
    totalCoinz: stats?.autosurf_total ?? 0,
  },
  {
    type: "Referral",
    totalCount:0,
    totalCoinz: stats?.referral_total ?? 0,
  },
];

const formatDateTime = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};



const progress = Math.min((userXP / xpForNextLevel) * 100, 100);

  // ⏳ ÉTAT DE CHARGEMENT : affichage d'un message de chargement tant que les données ne sont pas récupérées
  if (loading) return <div>Loading...</div>;
    

  return (
<>
  {showDailyBonusModal && <BonusModal onClose={() => setShowDailyBonusModal(false)} />}
  {showDrawModal && <DrawAvailableModal onClose={() => setShowDrawModal(false)} />}
  {showNewsModal && <UpdateModal onClose={handleCloseModal} />}

  <div className="min-h-screen flex flex-col bg-gray-900 text-gray-100 font-sans">
    {/* Contenu principal avec sidebar */}
    <div className="flex flex-1 min-h-[calc(100vh-64px)]">
      {/* Sidebar pleine hauteur */}
      <Sidebar onLogout={onLogout} />

      {/* Contenu à droite */}
      <main className="flex-1 px-8 py-10 space-y-12 overflow-auto min-w-0 bg-gray-900">
        <Header 
          title="Dashboard"  
          balance={coinz}        
          optionsOwned={options}        
          estimatedWeeklyGain={selfWeeklyProfit} 
        />

        <HighPerformanceAd
          keyId="fd5da3543c594f07b73630f461f10613"
          width={728}
          height={90}
        />

    
    {/* Nouveau bloc principal d'accueil */}
    <section className="w-full max-w-full mx-auto bg-gray-800/65 py-12 rounded-lg shadow-lg space-y-12 mb-10 px-4 sm:px-6">

<h2 className="text-2xl font-bold text-white text-center">Welcome, {username} </h2>

{/* Boutons remontés ici pour meilleure visibilité */}
<div className="flex flex-wrap justify-center gap-6 text-center">
  {/* Autosurf */}
  <div className="w-[400px] flex flex-col items-center justify-between p-4 rounded-lg h-full min-h-[140px] bg-transparent">
    <button
      onClick={() => window.location.href = "/autosurf"}
      className="flex items-center gap-2 bg-blue-700 hover:bg-blue-800 hover:scale-105 transition-transform duration-200 text-white py-3 px-6 rounded-md shadow-lg w-full ring-2 ring-blue-500/50"
    >
      <img src={iconSurf} alt="Coinz Icon" className="w-4 h-4 sm:w-6 sm:h-6" /> Launch Autosurf
    </button>
    <p className="text-gray-400 text-sm mt-2 w-full text-left">Earn up to ~12 Coinz/minute automatically.</p>
  </div>

  {/* Bonus */}
  {hasClaimableBonus && (
    <div className="w-[400px] flex flex-col items-center justify-between p-4 rounded-lg h-full min-h-[140px] bg-transparent">
      <button
        onClick={() => window.location.href = "/bonus"}
        className="flex items-center gap-2 bg-yellow-600 hover:bg-yellow-700 hover:scale-105 transition-transform duration-200 text-gray-900 py-3 px-6 rounded-md shadow-lg w-full ring-2 ring-yellow-500/50"
      >
        <img src={iconBonus} alt="Coinz Icon" className="w-4 h-4 sm:w-6 sm:h-6" /> Claim Bonus
      </button>
      <p className="text-gray-400 text-sm mt-2 w-full text-left">Get your daily 200 Coinz reward.</p>
    </div>
  )}

  {/* Draw */}
  <div className="w-[400px] flex flex-col items-center justify-between p-4 rounded-lg h-full min-h-[140px] bg-transparent">
    <button
      onClick={handleDrawClick}
      disabled={!isAvailable}
      className={`flex items-center gap-2 py-3 px-6 rounded-md shadow-lg transition-transform duration-200 hover:scale-105 w-full
        ${
          isAvailable
            ? "bg-gray-700 hover:bg-gray-600 text-gray-100 ring-2 ring-gray-400/50 cursor-pointer"
            : "bg-gray-500 text-gray-400 cursor-not-allowed hover:scale-100"
        }`}
    >
      <img src={iconDraw} alt="Coinz Icon" className="w-4 h-4 sm:w-6 sm:h-6" /> Try now a draw
    </button>
    <p
  className={`mt-2 w-full text-left font-semibold px-3 py-1 rounded ${
    isAvailable
      ? "text-cyan-400 text-lg bg-cyan-900/30 border border-cyan-400"
      : "text-gray-400 text-sm"
  }`}
>
  {isAvailable ? "Draw available!" : `Available in ${formatTime(timeLeft)}`}
</p>
  </div>
</div>

{/* Goal + How to Earn */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  <div className="bg-gray-700/35 p-4 sm:p-5 rounded-lg shadow-inner text-gray-100 text-sm">
    <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
      <img src={iconGoal} alt="Goal Icon" className="w-4 h-4 sm:w-5 sm:h-5" /> Goal Progress
    </h3>
    <p className="mb-3">
      You have <strong>{coinz}</strong> Coinz / 100,000 goal.
    </p>
    <Progress value={progressPercent} />
    <p className="mt-2 text-gray-400 text-sm">
      Withdraw estimated ~{Math.ceil((targetCoinz - coinz) / 5000)} day{Math.ceil((targetCoinz - coinz) / 5000) > 1 ? "s" : ""}.
    </p>
  </div>

  <div className="bg-gray-700/35 p-4 sm:p-5 rounded-lg shadow-inner text-gray-100 text-sm">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-lg font-semibold">💡 How to Earn Coinz Today</h3>
      <a
  href="/howitworks"
  title="FAQ - How to make money with CoinzUp"
  className="text-sm text-cyan-400 hover:underline break-words md:whitespace-nowrap"
>
  (How to make money with CoinzUp ?)
</a>
    </div>
    <ul className="list-disc list-inside text-gray-400 space-y-2">
      <li>Free hourly draw</li>
      <li>Autosurf: up to ~12 Coinz/minute</li>
      <li>Daily bonus: +200 Coinz and more</li>
      <li>Passive income with options</li>
    </ul>
  </div>
</div>

{/* Niveau + Parrainage */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  {/* Level Block */}
  <div className="bg-gray-700/35 p-4 sm:p-5 rounded-lg shadow-inner text-gray-100 flex flex-col justify-between text-sm">
    <div>
      <h3 className="text-lg font-semibold mb-4">Increase your level to improve your earnings</h3>
      <div className="flex items-center justify-between text-sm text-gray-400 mb-3">
        <span>{userLevel}</span>
        <span>{userXP} / {xpForNextLevel} XP</span>
      </div>
      <div className="w-full bg-gray-600 rounded-full h-2 mb-6">
        <div className="bg-blue-500 h-2 rounded-full transition-all" style={{ width: `${progress}%` }}></div>
      </div>
      <p className="text-xs text-gray-400 mb-3">
        Earn XP by using the site. Each level increases your earnings from <strong>draws</strong> and <strong>autosurf</strong>.
      </p>
    </div>
    <Link to="/levelup" className="self-end text-xs text-blue-400 hover:underline transition">
      More info →
    </Link>
  </div>

  {/* Referral Block */}
  <div className="bg-gray-700/35 p-4 sm:p-5 rounded-lg shadow-inner text-gray-100 flex flex-col justify-between text-sm">
    <div>
      <h3 className="text-lg font-semibold mb-4">Increase your profit with our referral program</h3>
      <div className="text-gray-400 text-sm mb-5 break-all">
        {`${window.location.origin}/register?refer=${refCode}`}
      </div>
      <button
        onClick={handleCopyReferral}
        className="bg-blue-700 hover:bg-blue-800 text-white text-sm px-4 py-2 rounded transition mb-5 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {copied ? "Copied ✅" : "Copy"}
      </button>
      <p className="text-xs text-gray-400 mb-3">
        Get <strong>5%</strong> of your referrals' rewards from draws, autosurf, and ad purchases.
      </p>
    </div>
    <Link to="/referral" className="self-end text-xs text-blue-400 hover:underline transition">
      More info →
    </Link>
  </div>
</div>

</section>

        {/* ON CONTINUE */}
        <RecentActivity history={history} />

        <HighPerformanceAd
          keyId="96e99453a24be0353f2fe26dc0b9b728"
          width={468}
          height={60}
        />
      </main>
    </div>

    {/* Footer tout en bas */}
    <Footer />
  </div>
</>
    );
  };
